export default __webpack_public_path__ + "ced19d487618de63ea34cbcf1af04638.webp";